import './Business.css';

function AboutBusiness() {
  const businessFields = [
    { title: '배연창 모터제어', value: 'DC/BLDC 모터를 사용한 창문 개폐장치 제어부분 [건축/소방]' },
    { title: '농축산 자동제어', value: '스마트팜 환경관리(온도, 습도, 창문, 어닝, 환기), 돈사 공조제어, 급이제어' },
    { title: '장비 자동제어', value: 'PLC/PC 및 전용제어기를 이용한 전자부품 품질검사장비, 연구개발 신뢰성 검사장비' },
    { title: '키오스크/자동판매기', value: '자동판매기 I/O 보드, 결제/기구/조명 제어' },
    { title: 'ICT/IoT', value: '범용 플랫폼을 가지는 ICT/IoT 서비스를 제공' },
    { title: '철도산업', value: 'HVAC, TVCU, DCU, TCMS Module' },
    { title: '전자제품', value: '커피관련기기, 식품가공기기' }
  ];

  return (
    <div className="overview-container">
      <div className="heat-section-title">사업분야</div>
      <div className="overview-table">
        {businessFields.map((item, index) => (
          <div key={index} className="overview-row">
            <div className="overview-title">{item.title}</div>
            <div className="overview-value">{item.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AboutBusiness;
